import {
  ConfirmActionModal,
  PageContentLayout,
} from '@tassomutuo-backoffice/ui';

import FilterEmailInput from '../profiles/components/FilterEmailInput';
import TeamsUsersTable from './components/TeamsUsersTable';
import useTeamsPage from './hooks/useTeamsPage';

const TeamsPage = () => {
  const {
    onSubmitFilterEmail,
    onTeamManagerCheckboxChange,
    onTeamChange,
    onRemoveMemberFromTeam,
    onCanReceiveLeadsCheckboxChange,
    onCanReceiveLeadsQuintoCheckboxChange,
    onCanReceiveLeadsPrestitoCheckboxChange,
    usersData,
    isPending,
    isPendingTeams,
    tableState,
    setTableState,
    teamsData,
    modalConfig,
    setModalState,
  } = useTeamsPage();

  return (
    <>
      <PageContentLayout title="Gestione Teams" error={null}>
        <FilterEmailInput onSubmit={onSubmitFilterEmail} />

        <TeamsUsersTable
          rowCount={usersData?.totalResults || 0}
          isPending={isPending || isPendingTeams}
          paginationModel={tableState.pagination}
          setPaginationModel={(paginationModel) =>
            setTableState({
              ...tableState,
              pagination: paginationModel,
            })
          }
          users={usersData?.results || []}
          onTeamManagerCheckboxChange={onTeamManagerCheckboxChange}
          teams={teamsData || []}
          onTeamChange={onTeamChange}
          onRemoveMemberFromTeam={onRemoveMemberFromTeam}
          onCanReceiveLeadsCheckboxChange={onCanReceiveLeadsCheckboxChange}
          onCanReceiveLeadsQuintoCheckboxChange={onCanReceiveLeadsQuintoCheckboxChange}
          onCanReceiveLeadsPrestitoCheckboxChange={onCanReceiveLeadsPrestitoCheckboxChange}
        />
      </PageContentLayout>
      {modalConfig && (
        <ConfirmActionModal
          open
          title={modalConfig.title}
          description={modalConfig.description}
          handleClose={() =>
            setModalState({
              userToChangeTeamManager: null,
              addMemberToTeam: null,
              removeMemberFromTeam: null,
              userToChangeCanReceiveLeads: null,
              userToChangeCanReceiveLeadsQuinto: null,
              userToChangeCanReceiveLeadsPrestito: null,
            })
          }
          onConfirm={modalConfig.onConfirm}
        />
      )}
    </>
  );
};

export default TeamsPage;
